



















import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    id: String as PropType<string>,
    value: Boolean as PropType<boolean>,
    state: Boolean as PropType<boolean | null>,
  },
  methods: {
    handleInput(value: Event) {
      const inputElement = value.target as HTMLInputElement;
      this.$emit('input', inputElement.checked);
    },
  },
});
